export default __webpack_public_path__ + "static/media/12-7.632dd185.png";